import { Form, InputNumber, Modal, Select } from 'antd'
import React from 'react'

interface DormFloorModalProps {
    form: any;
    open: boolean;
    onFinish: (values: any) => void;
    onCancel: () => void;
    genderList?: any[];
}

const DormFloorModal = ({ form, open, onCancel, onFinish, genderList }: DormFloorModalProps) => {
    return (
        <Modal
            title="Dormitory gender floor"
            onOk={() => form.submit()}
            open={open}
            destroyOnClose
            onCancel={onCancel}
        >
            <Form
                form={form}
                name="dormitory"
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item
                    label="Id"
                    name="id"
                    hidden
                    noStyle
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label="Floor"
                    name="floor"
                    hidden
                    noStyle
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label="Gender"
                    name="genderId"
                    rules={[{ required: true, message: 'Please select gender!' }]}
                >
                    <Select>
                        {genderList?.map((gender) => (
                            <Select.Option key={gender.id} value={gender.id}>
                                {gender.value}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal >
    )
}

export default DormFloorModal